import { graphql, useStaticQuery } from 'gatsby';

import { MewaCircleType } from '@mewa/types';
import { MewaCircle, MewaCircleData, MewaCircleProps } from '@mewa/ui';

export const StrapiMewaCircleCertainVariant = ({
  title,
  circleVariant,
  link,
  locale,
  className = '',
}: {
  title?: string;
  circleVariant: MewaCircleType;
  link?: MewaCircleProps['link'];
  locale: string;
  className?: string;
}) => {
  const {
    allStrapiMewaCircle: { nodes: mewaCircles },
  } = useStaticQuery<{
    allStrapiMewaCircle: {
      nodes: MewaCircleData[];
    };
  }>(graphql`
    query {
      allStrapiMewaCircle {
        nodes {
          circleVariant
          locale
          firstStep {
            description
            headline
            icon
          }
          secondStep {
            description
            headline
            icon
          }
          thirdStep {
            description
            headline
            icon
          }
          fourthStep {
            description
            headline
            icon
          }
          fifthStep {
            headline
            description
            icon
          }
        }
      }
    }
  `);

  const mewaCircleToShow = mewaCircles.find(
    (circle) =>
      circle.circleVariant === circleVariant && circle.locale === locale,
  );

  return mewaCircleToShow ? (
    <MewaCircle
      className={className}
      title={title}
      circle={mewaCircleToShow}
      link={link}
    />
  ) : null;
};
